<dx-popup
    title="Dumpster Fee"
    [width]="400"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="dumpsterFeeType" class="mb-4" validationGroup="mainValidationGroup">
        <dxi-form-item dataField="name">
            <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="visibleForPickup" editorType="dxCheckBox"></dxi-form-item>
        <dxi-form-item dataField="visibleForDropOff" editorType="dxCheckBox"></dxi-form-item>
        <dxi-form-item dataField="price" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
            <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
            <dxi-form-validation-rule type="range" [min]="0" message="cannot be negative"></dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item [label]="{ text: 'Associated Dumpsters' }">
            <div *dxTemplate>
                <dx-list
                    [items]="dumpsters"
                    keyExpr="id"
                    [(selectedItemKeys)]="selectedDumpsterIds"
                    selectionMode="multiple"
                    [showSelectionControls]="true"
                    itemTemplate="listItem"
                >
                    <div *dxTemplate="let item of 'listItem'">
                        {{ item.size }}
                    </div>
                </dx-list>
            </div>
        </dxi-form-item>
    </dx-form>
</dx-popup>
